import React, {
  useEffect, useRef, useState, useCallback, ReactElement,
} from 'react';
import {
  ActivityIndicator, Animated, BackHandler, FlatList, Platform, Pressable, RefreshControl,
  StyleSheet, Text, TextInput, TouchableOpacity, View,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Modal from 'react-native-modal';
import NfcManager, { NfcTech } from 'react-native-nfc-manager';
import * as Animatable from 'react-native-animatable';
import { useFocusEffect } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { CameraView, useCameraPermissions } from 'expo-camera';
import SearchIcon from '../components/SearchIcon';
import Colors from '../constants/Colors';
import getAssets from '../requests/Assets/GetAssets';
import { RootTabScreenProps } from '../types';
import EllipsisIcon from '../components/EllipsisIcon';
import OrionArrowIcon from '../components/24pxIcons/OrionArrowIcon';
import PlusIcon from '../components/16pxIcons/PlusIcon';
import AddTemplateGroupModal from '../components/AssetManagement/AddTemplateGroupModal';
import LeftArrow16 from '../components/16pxIcons/LeftArrow16';
import TemplateRowMobile from '../components/AssetManagement/TemplateRowMobile';
import TemplateSideBarRow from '../components/AssetManagement/TemplateSideBarRow';
import CheckBox from '../components/16pxIcons/CheckBox';
import AssetRowMobile from '../components/AssetManagement/AssetRowMobile';
import AssetCardMobile from '../components/AssetManagement/AssetCardMobile';
import DownloadIcon from '../components/DownloadIcon';
import FilterIconMobile16 from '../components/16pxIcons/FilterIconMobile';
import ScanIcon16 from '../components/16pxIcons/ScanIcon16';
import AddAssetModal from '../components/AssetManagement/AddAssetModal';
import CloseModalIcon from '../components/CloseModalIcon';
import Style from '../constants/Style';
import AlertModal from '../components/AlertModal';
import SearchResultsPane from '../components/AssetManagement/SearchResultsPane';
import ReportIssueIcon from '../components/12pxIcons/ReportIssueIcon';
import ReportTicketModal from '../components/AssetManagement/ReportTicketModal';
import AddTemplateModal from '../components/AssetManagement/AddTemplateModal';
import getTemplateGroups from '../requests/Assets/GetTemplateGroups';
import ScreenEmptyState from '../components/ScreenEmptyState';
import NoTemplateGroupsImage from '../components/AssetManagement/NoTemplateGroupsImage';
import isMobile from '../components/IsMobile';
import NoTemplatesImage from '../components/AssetManagement/NoTemplatesImage';
import NoAssetsImage from '../components/AssetManagement/NoAssetsImage';
import getTemplateSpreadsheet from '../requests/Assets/GetTemplateSpreadsheet';
import EditAssetModal from '../components/AssetManagement/EditAssetModal';
import EditIcon from '../components/EditIcon';
import retireAsset from '../requests/Assets/RetireAsset';
import BinIcon from '../components/BinIcon';
import { logEvent } from '../components/LogEvent';
import AssetFilter from '../components/AssetManagement/AssetFilter';
import {
  AssetInstance, Template, TemplateGroup, UserPermission,
} from '../constants/Types';
import getAsset from '../requests/Assets/GetAsset';
import { loadCustomFields } from '../components/AssetManagement/data';
import { DELETE_ASSET_SUCCESS, PPM_URL_MISSING } from '../constants/AlertMessages';
import { openInNewTab } from '../constants/Utils';
import NfcIcon24 from '../components/24pxIcons/NfcIcon24';
import NfcIcon from '../components/30pxIcons/NfcIcon';
import Button from '../components/Button';
import PressableStyled from '../components/PressableStyled';

export default function TemplateMgmtScreenMobile({
  // eslint-disable-next-line no-unused-vars
  navigation, route,
}: RootTabScreenProps<'AssetManagement'>) {
  // eslint-disable-next-line no-unused-vars
  const [assetsLoading, setAssetsLoading] = useState<boolean>(false);
  const [templatesLoading, setTemplatesLoading] = useState<boolean>(true);
  const [exportDropdownShown, setExportDropdownShown] = useState<boolean>(false);
  const [exporting, setExporting] = useState<boolean>(false);
  const [selectedAssetTags, setSelectedAssetTags] = useState<string[]>([]);
  const [selectedAssetTagIndex, setSelectedAssetTagIndex] = useState<number>(0);
  const [addTemplateModalVisible, setAddTemplateModalVisible] = useState<boolean>(false);
  const [reportIssueModalVisible, setReportIssueModalVisible] = useState<boolean>(false);
  const [editAssetVisible, setEditAssetVisible] = useState<boolean>(false);
  const [ticketCountRefresh, setTicketCountRefresh] = useState<number>(0);
  const [linkAssetsView, setLinkAssetsView] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>(null);
  const [optionsSelected, setOptionsSelected] = useState<boolean>(null);
  const [templateGroups, setTemplateGroups] = useState([]);
  const [templates, setTemplates] = useState<Template[]>(null);
  const [floors, setFloors] = useState(null);
  const [rooms, setRooms] = useState(null);
  const [allAssets, setAllAssets] = useState<AssetInstance[]>([]);
  const [assets, setAssets] = useState<AssetInstance[]>([]);
  const [selectedGroupID, setSelectedGroupID] = useState<string>(null);
  const [selectedTemplate, setSelectedTemplate] = useState<Template>(null);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [assetFilterVisible, setAssetFilterVisible] = useState<boolean>(false);
  const [detailedFilterVisible, setDetailedFilterVisible] = useState<boolean>(false);
  const [assetFilterLoading, setAssetFilterLoading] = useState<boolean>(false);
  const [assetFilterResults, setAssetFilterResults] = useState<AssetInstance[]>([]);
  const [roomSelected, setRoomSelected] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [assetCount, setAssetCount] = useState<number>(0);
  const [allSelected, setAllSelected] = useState<boolean>(null);
  const [searchValue, setSearchValue] = useState<string>(null);
  const [addGroupModalVisible, setAddGroupModalVisible] = useState<boolean>(false);
  const [templateDrawerInset] = useState(new Animated.Value(-300));
  const [assetDrawerOpen, setAssetDrawerOpen] = useState<boolean>(false);
  const [templateDrawerOpen, setTemplateDrawerOpen] = useState<boolean>(false);
  const [sortById, setSortById] = useState<boolean>(true);
  const [selectAsset, setSelectAsset] = useState<AssetInstance>(null);
  const [scanned, setScanned] = useState<boolean>(true);
  const [addAssetModalVisible, setAddAssetModalVisible] = useState<boolean>(false);
  const [templateSideBarContext, setTemplateSideBarContext] = useState<string>(null);
  const [status, requestPermission] = useCameraPermissions();

  const showParentAnalytics: boolean = false;
  const deleteEnabled: boolean = false;

  const assetDrawerInset = useRef(new Animated.Value(-300)).current;
  const templateMenuList = useRef<FlatList>(null);
  const templateGroupList = useRef<FlatList>(null);

  const buildings: object = useSelector((state:
    { locations: { buildings } }) => state.locations.buildings);
  const selectedBuildingId: string = useSelector((state:
    { selectedBuilding: { id: string } }) => state.selectedBuilding.id);
  const { isAdmin, permissions }: { isAdmin: boolean, permissions: UserPermission[] } = useSelector(
    (state: { user: { isAdmin: boolean, permissions: UserPermission[] } }) => state.user,
  );
  const canAddTemplates: boolean = isAdmin
    || permissions?.includes(UserPermission.TEMPLATES_CREATE);
  const canAddAssets: boolean = isAdmin
    || permissions?.includes(UserPermission.ASSETS_CREATE);
  const canUpdateAssets: boolean = isAdmin
    || permissions?.includes(UserPermission.ASSETS_UPDATE);
  const canDeleteAssets: boolean = isAdmin
    || permissions?.includes(UserPermission.ASSETS_DELETE);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);
  const [alertError, setAlertError] = useState<boolean>(true);
  const [alertIsMessage, setAlertIsMessage] = useState(false);
  const [alertTitle, setAlertTitle] = useState<string>('');
  const [alertMessage, setAlertMessage] = useState<string | ReactElement>('');
  const [alertAction, setAlertAction] = useState<() => void>(null);
  const [alertActionTitle, setAlertActionTitle] = useState<string>('');
  const [noDataAlertShown, setNoDataAlertShown] = useState<boolean>(false);
  const [nfcPressed, setNfcPressed] = useState<boolean>(false);

  const showScreenAlert = (
    title: string,
    message?: string | ReactElement,
    error: boolean = true,
    action: () => void = null,
    actionTitle: string = '',
    isMessage: boolean = false,
  ) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertError(error);
    setAlertAction(() => action);
    setAlertActionTitle(actionTitle);
    setAlertVisible(true);
    setNoDataAlertShown(true);
    setAlertIsMessage(isMessage);
  };

  const deleteError = (errorText?: string) => showScreenAlert(
    'Error',
    errorText ?? 'Unable to delete the asset at the moment. Please try again later',
  );

  const decodePayload = (payload: number[]): string => {
    const filteredPayload = payload.slice(1);
    return String.fromCharCode(...filteredPayload);
  };

  const handleBarCodeScanned = ({ data }) => {
    setScanned(true);
    const scanValue = data.split('.tech/')[1]?.split('?')[0];
    getAsset(scanValue).then((res: AssetInstance | null) => {
      if (res && res.id) setSelectAsset(res);
      else showScreenAlert('Error', 'No asset associated with this Solve tag');
    });
  };

  // eslint-disable-next-line func-names
  const groupBy = function <TItem> (xs: TItem[], key: string): { [key: string]: TItem[] } {
    return xs?.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const closeMenus = () => {
    setTemplateSideBarContext(null);
    setTemplateDrawerOpen(false);
    setAssetDrawerOpen(false);
    setOptionsSelected(null);
    setExportDropdownShown(false);
  };

  const clearTabSelection = () => {
    setSearchValue('');
    setAssets([]);
    setSelectedTemplate(null);
    setAllSelected(false);
    setSelectedGroupID(null);
    setTemplateSideBarContext(null);
    setOptionsSelected(null);
    setSelectedId(null);
    if (templateDrawerOpen) {
      setTemplateDrawerOpen(false);
    }
    if (assetDrawerOpen) {
      setAssetDrawerOpen(false);
    }
    setSelectAsset(null);
    clearAssetSearchResults();
    closeMenus();
  };

  useEffect(() => {
    if ((route?.params as any)?.assetsView) setLinkAssetsView(true);
    if (!(templates && !templatesLoading)) return;
    const assetId: string = (route?.params as any)?.assetId;
    const templateId: string = (route?.params as any)?.templateId;
    if (assetId || templateId) {
      const filteredTemplate = templates.filter((template) => template.id === templateId)[0];
      if (filteredTemplate) {
        setAssets([]);
        setAssetsLoading(true);
        setSelectedTemplate(filteredTemplate);
        setLinkAssetsView(true);
      } else {
        showScreenAlert('Error', 'Linked template could not be found. It may have been deleted.');
      }

      navigation.setParams({ templateId: undefined, assetId: undefined } as any);
    }

    if (assetId) setSelectedAssetId(assetId);
  }, [templates, templatesLoading, route]);

  useEffect(() => {
    if (!(selectedAssetId && selectedTemplate && !assetsLoading)) return;
    const filteredAsset = assets
      ?.filter((asset: AssetInstance) => asset.id === selectedAssetId)[0];
    if (filteredAsset) setSelectAsset(filteredAsset);
    else {
      showScreenAlert('Error', 'Linked asset could not be found. It may have been deleted.');
    }
    setSelectedAssetId(null);
  }, [selectedTemplate, selectedAssetId, assetsLoading]);

  const noTemplatesFound = () => {
    if (!noDataAlertShown) {
      setTemplates([]);
      showScreenAlert('Error', 'Could not load asset templates at the moment. Please try again later.');
      setNoDataAlertShown(true);
      setTemplatesLoading(false);
    }
  };

  const noAssetsFound = (errorText?: string) => {
    if (!noDataAlertShown) {
      showScreenAlert(
        'Error',
        errorText ?? 'Could not load assets at the moment. Please try again later.',
      );
      setNoDataAlertShown(true);
      setAssetsLoading(false);
    }
  };

  const loadTemplateGroups: () => void = () => {
    setTemplatesLoading(true);
    getTemplateGroups().then((response) => {
      if (!response?.groups) noTemplatesFound();
      else {
        setTemplateGroups(response?.groups?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name
          ?.toLowerCase().localeCompare(b.Name?.toLowerCase())) ?? []);
        const templateDataList: Template[] = response?.groups?.reduce((prev, group) => {
          if (group?.buttonPrototypes?.length) return prev.concat(group.buttonPrototypes);
          return prev;
        }, []) ?? [];
        setTemplates(templateDataList);
      }
      setTemplatesLoading(false);
    }).catch(noTemplatesFound);
  };

  useEffect(loadTemplateGroups, []);

  useEffect(() => setTemplateSideBarContext(null), [templateDrawerOpen]);

  useEffect(() => {
    if (assetDrawerOpen && selectedTemplate) {
      templates?.forEach((template, index) => {
        if (template.id === selectedTemplate.id) {
          templateMenuList?.current?.scrollToIndex({ index, viewPosition: 0.5 });
        }
      });
    }
  }, [assetDrawerOpen]);

  useEffect(() => {
    if (templateDrawerOpen && selectedGroupID) {
      templateGroups?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name
        ?.toLowerCase().localeCompare(b.Name?.toLowerCase()))
        ?.forEach((templateGroup, index) => {
          if (templateGroup.ButtonPrototypeGroupId === selectedGroupID) {
            templateGroupList?.current?.scrollToIndex({ index, viewPosition: 0.5 });
          }
        });
    }
  }, [templateDrawerOpen]);

  useEffect(() => {
    getAssets({ locationId: selectedBuildingId, enableSubLocationsLookUp: true })
      .then((res) => setAllAssets(res.assets));
  }, []);

  const loadAssets = () => {
    if (selectedTemplate) {
      getAssets({ templateId: selectedTemplate?.id, locationId: selectedBuildingId })
        .then((response) => {
          if (response?.assets) {
            const groupFloors = groupBy(response.assets, 'LocationFloor');
            const groupRooms = groupBy(
              response.assets?.sort((a, b) => a.LocationRoom?.localeCompare(b.LocationRoom)),
              'LocationRoom',
            );
            setFloors(groupFloors);
            setRooms(groupRooms);
            if (response.assets.length > 0) {
              setAssets(response.assets);
            }
            setAssetsLoading(false);
          } else noAssetsFound(response?.errorText);
        }).catch((error) => noAssetsFound(error?.message));
    } else if (searchValue) {
      getAssets({
        locationId: selectedBuildingId,
        textSearch: searchValue,
        enableSubLocationsLookUp: true,
      }).then((response) => {
        if (response?.assets) {
          setAssetsLoading(false);
        } else noAssetsFound(response?.errorText);
      }).catch((error) => noAssetsFound(error?.message));
    } else if (!(route?.params as any)?.assetId) {
      setAssetsLoading(false);
    }
  };

  const updateTemplateLocally = (template: Template, add: boolean, groupID: string) => {
    if (!template?.id) return;
    setTemplatesLoading(true);
    if (add) {
      setTemplateGroups(templateGroups.map((group: TemplateGroup) => ({
        ...group,
        buttonPrototypes: group.ButtonPrototypeGroupId === groupID
          ? [...group.buttonPrototypes, template] : group.buttonPrototypes,
      })));
      setTemplates([...templates, template]);
    } else {
      setTemplateGroups(templateGroups.map((group: TemplateGroup) => ({
        ...group,
        buttonPrototypes: group.buttonPrototypes.map((t: Template) => ({
          ...t,
          ...(t.id === template.id ? template : {}),
        })),
      })));
      setTemplates(templates
        .map((t: Template) => ({ ...t, ...(t.id === template.id ? template : {}) })));
    }
    if (selectedTemplate && selectedTemplate.id === template.id) setSelectedTemplate(template);
  };

  useEffect(() => {
    loadAssets();
    const getBarCodeScannerPermissions = async () => {
      if (!status || (!status?.granted && status?.canAskAgain)) requestPermission();
    };

    getBarCodeScannerPermissions();
  }, [selectedTemplate, selectedBuildingId, route]);

  useEffect(() => setTemplateSideBarContext(null), [
    selectAsset, selectedTemplate, selectedGroupID, addTemplateModalVisible, addGroupModalVisible,
  ]);

  useEffect(() => {
    if (!assetDrawerOpen) {
      Animated.timing(assetDrawerInset, {
        toValue: -300,
        duration: 200,
        useNativeDriver: true,
      }).start();
    } else {
      Animated.timing(assetDrawerInset, {
        toValue: 0,
        duration: 200,
        useNativeDriver: true,
      }).start();
    }
  }, [assetDrawerInset, assetDrawerOpen]);

  useEffect(() => {
    if (!templateDrawerOpen) {
      Animated.timing(templateDrawerInset, {
        toValue: -300,
        duration: 200,
        useNativeDriver: true,
      }).start();
    }
  }, [templateDrawerOpen]);

  useEffect(() => {
    let count = 0;
    Object.keys(floors ?? []).map((floor) =>
      // eslint-disable-next-line implicit-arrow-linebreak, consistent-return
      floors[floor]?.forEach((instance) => {
        if (
          instance.LocationRoom === selectedRoom?.LocationRoom
          || instance.templateId === selectedId
        ) {
          count += 1;
        }
      }));
    setAssetCount(count);
  }, [selectedRoom, selectedId, assetsLoading, assets]);

  useEffect(() => {
    if (templatesLoading && templates) setTemplatesLoading(false);
  }, [templates]);

  useFocusEffect(
    useCallback(() => {
      const onBackPress = () => {
        if (selectAsset !== null) {
          setSelectAsset(null);
          return true;
        }
        return false;
      };

      const subscription = BackHandler.addEventListener('hardwareBackPress', onBackPress);

      return () => subscription.remove();
    }, [selectAsset]),
  );

  const clearAssetSearchResults = () => {
    setAssetFilterResults([]);
    setDetailedFilterVisible(false);
  };

  const exportError = (errorText: string) => {
    setExporting(false);
    showScreenAlert('Error', errorText ?? 'Unable to export data at the moment. Please try again later.');
  };

  const exportData = (buildingId?: string) => {
    setExporting(true);
    setExportDropdownShown(false);
    getTemplateSpreadsheet(buildingId).then((response) => {
      if (response && response.url?.length > 0) {
        openInNewTab(response.url);
      } else exportError(response?.errorText);
      setExporting(false);
    }).catch((error) => exportError(error?.message));
  };

  useEffect(() => {
    clearAssetSearchResults();
    setSelectAsset(null);
    setSearchValue('');
  }, [selectedTemplate]);

  const filterAssets = () => {
    let assetsToRender: AssetInstance[] = assets;
    if (sortById) {
      assetsToRender = assets
        .sort((a: AssetInstance, b: AssetInstance) => a.name?.localeCompare(b.name));
    } else if (!sortById) {
      assetsToRender = assets
        .sort((a: AssetInstance, b: AssetInstance) => b.name?.localeCompare(a.name));
    }
    if (selectedTemplate) {
      assetsToRender = assetsToRender?.filter((asset: AssetInstance) => asset
        .templateId === selectedTemplate?.id);
    } else if (selectedRoom) {
      assetsToRender = assetsToRender?.filter((asset: AssetInstance) => asset
        ?.locationId === selectedRoom?.locationId);
    }
    return assetsToRender;
  };

  const renderTemplate = (template: any) => (
    <TouchableOpacity
      disabled={!assetDrawerOpen}
      onPress={() => {
        logEvent('AssetMgmtScreenMobile', 'selected_template');
        if (selectedTemplate !== null && selectedTemplate?.id === template.id) {
          setSelectedTemplate(null);
          setSelectedId(null);
        } else {
          setSelectedTemplate(template);
          setSelectedId(template.id);
        }
        setAllSelected(false);
        setAssetDrawerOpen(false);
      }}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor:
          selectedTemplate?.id === template.id ? Colors.light.hereworksDarkBlue : 'transparent',
      }}
    >
      <Text
        style={[
          styles.sectionTitle,
          {
            color: selectedTemplate?.id === template.id ? '#fff' : Colors.light.hereworksBlack500,
          },
        ]}
      >
        {template.name}
      </Text>
      {!linkAssetsView && (
        <EllipsisIcon fill={'#D9D9D9'} style={{ position: 'absolute', right: 24 }} />
      )}
    </TouchableOpacity>
  );

  const renderRoom = (room: any) => (
    <Pressable
      onPress={() => {
        logEvent('AssetMgmtScreenMobile', 'room_selected');
        if (selectedRoom !== null && selectedRoom?.LocationId === room[0]?.LocationId) {
          setSelectedRoom(null);
        } else {
          setSelectedRoom(room[0]);
        }
        setAllSelected(false);
        setAssetDrawerOpen(false);
      }}
      style={(state) => [{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor:
          selectedRoom?.LocationId === room[0]?.LocationId
            ? Colors.light.hereworksDarkBlue
            : 'transparent',
      }, state.pressed && Style.pressed]}
    >
      <Text
        style={[
          styles.sectionTitle,
          {
            color: selectedRoom?.LocationId === room[0]?.LocationId
              ? '#fff' : Colors.light.hereworksBlack500,
          },
        ]}
      >
        {room[0]?.LocationRoom}
      </Text>
      {!linkAssetsView && (
        <EllipsisIcon fill={'#D9D9D9'} style={{ position: 'absolute', right: 24 }} />
      )}
    </Pressable>
  );

  const renderTemplatesFromList = (templateList) => <FlatList
    removeClippedSubviews={false}
    ListEmptyComponent={() => <ScreenEmptyState
      style={isMobile && styles.mobileEmptyState}
      image={<NoTemplatesImage />}
      title='Add your first template'
      subtitle={'Add a template to work with.\nContact your system administrator to create a template'}
      adminSubtitle={'Add a template to work with'}
      actionAvailable={canAddTemplates}
      buttonTitle='Add template'
      buttonAction={() => setAddTemplateModalVisible(true)}
    />}
    keyExtractor={(item) => `template_list_item_${item.id}`}
    renderItem={({ item }) => !item.deleted && <View
      style={{ zIndex: 4 }}
    >
      {
        <TemplateRowMobile
          {... { optionsSelected, templateGroups, setOptionsSelected }}
          update={updateTemplateLocally}
          setLinkAssetsView={() => {
            setLinkAssetsView(!linkAssetsView);
            setSelectedTemplate(item);
            setAllSelected(false);
          }}
          showParentAlert={showScreenAlert}
          setSelectedId={() => setSelectedId(item.id)}
          deleteAction={() => {
            setTemplatesLoading(true);
            loadTemplateGroups();
          }}
          template={item}
        />
      }
    </View>}
    data={templateList
      ?.sort((prev: Template, next: Template) => prev.name?.localeCompare(next.name))}
    onScrollToIndexFailed={() => { }}
    refreshing={templatesLoading}
    onRefresh={loadTemplateGroups}
  />;

  const renderTemplates = () => {
    if (selectedGroupID === null) return renderTemplatesFromList(templates);
    return renderTemplatesFromList(templateGroups?.filter((group) => group.ButtonPrototypeGroupId
      === selectedGroupID)[0]?.buttonPrototypes ?? templates);
  };

  const renderTemplateSidebar = () => (
    <>
      {templateDrawerOpen && (
        <Pressable
          style={{
            backgroundColor: '#00000040',
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 5,
          }}
          onPress={() => {
            logEvent('AssetMgmtScreenMobile', 'template_drawer_background');
            setTemplateDrawerOpen(false);
          }}
        />
      )}
      <Animated.View
        style={{
          width: 300,
          backgroundColor: Colors.light.hereworksBlue50,
          position: 'absolute',
          left: 0,
          height: '100%',
          zIndex: 6,
          transform: [{ translateX: templateDrawerInset }],
        }}
      >
        <View
          style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <View>
            <Text
              style={{
                fontFamily: 'Roboto_500Medium',
                fontSize: 12,
                lineHeight: 14,
                color: Colors.light.hereworksBlack500,
                marginTop: 24,
                marginStart: 24,
              }}
            >
              TEMPLATE GROUPS
            </Text>
            <Text
              style={{
                fontFamily: 'Roboto_400Regular',
                fontSize: 12,
                lineHeight: 14,
                color: Colors.light.hereworksBlack500,
                marginTop: 12,
                marginStart: 24,
                marginBottom: 17,
              }}
            >
              Choose template group
            </Text>
          </View>
          {canAddTemplates && <PressableStyled
            style={{
              backgroundColor: Colors.light.hereworksBlue500,
              borderRadius: 4,
              padding: 6,
              marginRight: 24,
            }}
            onPress={() => {
              logEvent('AssetMgmtScreenMobile', 'Add_Template_Group');
              setAddGroupModalVisible(!addGroupModalVisible);
            }}
          >
            <PlusIcon />
          </PressableStyled>}
          <AddTemplateGroupModal
            {...{ templateGroups }}
            isVisible={addGroupModalVisible}
            hide={() => setAddGroupModalVisible(false)}
            update={(Name: string, ButtonPrototypeGroupId: string, create: boolean) => {
              const updatedTemplateGroups = [...templateGroups];
              if (create) {
                updatedTemplateGroups
                  .push({ Name, ButtonPrototypeGroupId, buttonPrototypes: [] });
              } else {
                updatedTemplateGroups?.forEach((group) => {
                  if (group.ButtonPrototypeGroupId === ButtonPrototypeGroupId) {
                    group.Name = Name;
                  }
                });
              }
              setTemplateGroups(updatedTemplateGroups
                ?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name
                  ?.toLowerCase().localeCompare(b.Name?.toLowerCase())));
            }}
          />
          <AddTemplateModal
            {...{ templateGroups }}
            defaultTemplateGroupID={selectedGroupID}
            isVisible={addTemplateModalVisible}
            hide={() => setAddTemplateModalVisible(false)}
            update={updateTemplateLocally}
            showParentAlert={showScreenAlert}
          />
        </View>
        <View
          style={{ backgroundColor: Colors.light.hereworksBlue100, height: 1, width: '100%' }}
        />
        <View style={{ flex: 1 }}>
          <FlatList
            ref={(ref) => {
              templateGroupList.current = ref;
            }}
            removeClippedSubviews={false}
            style={{ flexGrow: 1 }}
            contentContainerStyle={{ flexDirection: 'column-reverse', paddingBottom: 40 }}
            data={templateGroups
              ?.sort((prev: TemplateGroup, next: TemplateGroup) => next.Name.toLowerCase()
                .localeCompare(prev.Name.toLowerCase()))}
            keyExtractor={(item) => `template_group_menu_item_${item.ButtonPrototypeGroupId}`}
            renderItem={({ item }) => <TemplateSideBarRow
              {...{ selectedGroupID, templateGroups, showScreenAlert }}
              group={item}
              onPress={() => {
                if (selectedGroupID === item.ButtonPrototypeGroupId) {
                  setSelectedGroupID(null);
                } else {
                  setSelectedGroupID(item.ButtonPrototypeGroupId);
                }
                setTemplateDrawerOpen(false);
              }}
              deleteAction={() => {
                if (item.ButtonPrototypeGroupId === selectedGroupID) setSelectedGroupID(null);
                setTemplateGroups(
                  templateGroups?.filter((i) => i.ButtonPrototypeGroupId
                    !== item.ButtonPrototypeGroupId),
                );
              }}
              contextMenuOpen={() => setTemplateSideBarContext(item.ButtonPrototypeGroupId)}
              contextMenuClose={() => setTemplateSideBarContext(null)}
              currentContextMenu={templateSideBarContext}
              update={(newName: string, id: string, create?: boolean, toDelete?: boolean) => {
                if (create) {
                  setTemplateGroups([
                    ...templateGroups, { Name: newName, ButtonPrototypeGroupId: id },
                  ]?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name
                    ?.toLowerCase().localeCompare(b.Name?.toLowerCase())));
                } else if (toDelete) {
                  setTemplateGroups(templateGroups?.filter((group: TemplateGroup) => group
                    .ButtonPrototypeGroupId !== id)
                    ?.sort((a: TemplateGroup, b: TemplateGroup) => a.Name
                      ?.toLowerCase().localeCompare(b.Name?.toLowerCase())));
                } else {
                  setTemplateGroups(templateGroups?.map((group: TemplateGroup) => (group
                    .ButtonPrototypeGroupId === id ? { ...group, Name: newName } : group)));
                }
              }}
              mobile
            />}
            ListEmptyComponent={<View style={styles.noTemplateGroupsMessage}>
              <Text style={styles.noTemplatesTitle}>
                {'No templates groups have been created yet'}
              </Text>
              {canAddTemplates && <Text style={styles.noTemplatesSubtitle}>
                {'Add a template group by pressing the \'+\' button above'}
              </Text>}
            </View>}
            onScrollToIndexFailed={() => { }}
          />
        </View>
      </Animated.View>
    </>
  );

  const renderManageGroupsView = () => (
    <Animatable.View
      animation={'fadeIn'}
      style={{
        marginTop: 20,
        flex: 1,
        flexDirection: 'row',
        backgroundColor: '#fff',
      }}
    >
      {renderTemplateSidebar()}
      <View
        style={{
          flex: 1,
          zIndex: 4,
        }}
      >
        <View style={{ zIndex: 4, flex: 1 }}>
          {templateGroups?.length > 0 ? <>
            <Text
              style={{
                fontFamily: 'Roboto_500Medium',
                fontSize: 12,
                lineHeight: 20,
                color: Colors.light.hereworksBlack500,
                marginTop: 16,
                marginStart: 24,
              }}
            >
              TEMPLATES
            </Text>
            {selectAsset === null && (<>
              <View style={styles.searchBoxRow}>
                <View style={styles.searchBox}>
                  <SearchIcon style={{ marginStart: 14 }} />
                  <TextInput
                    placeholder="Search"
                    onFocus={closeMenus}
                    style={styles.searchText}
                    placeholderTextColor={Colors.light.hereworksBlack400}
                    value={searchValue}
                    onChangeText={(text) => {
                      setSearchValue(text);
                    }}
                  />
                </View>
              </View>
              {renderSearchPane()}
              <View
                style={{
                  backgroundColor: Colors.light.hereworksBlue100,
                  height: 1,
                  marginTop: 20,
                  width: '100%',
                }}
              />
            </>
            )}
          </> : <></>}
          {selectedGroupID !== null && (
            <Text
              style={{
                fontFamily: 'Poppins_400Regular',
                fontSize: 16,
                lineHeight: 24,
                color: Colors.light.hereworksBlack600,
                marginTop: 16,
                marginStart: 24,
              }}
            >
              {templateGroups?.filter((group) => group.ButtonPrototypeGroupId
                === selectedGroupID)[0]?.Name}
            </Text>
          )}
          {templateGroups?.length > 0
            ? <View style={{ marginTop: 8, flex: 1 }}>{renderTemplates()}</View>
            : !templatesLoading && <ScreenEmptyState
              style={isMobile && styles.mobileEmptyState}
              image={<NoTemplateGroupsImage />}
              title='Start with a template group'
              subtitle={'In template groups you will collect your templates.\nContact your system administrator to create a template group'}
              adminSubtitle={'In template groups you will collect your templates.\nPlease create a template group'}
              actionAvailable={canAddTemplates}
              buttonTitle='Add template group'
              buttonAction={() => setAddGroupModalVisible(true)}
            />}
        </View>
        <View style={styles.bottomButtons}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => {
              setTemplateDrawerOpen(true);
              Animated.timing(templateDrawerInset, {
                toValue: 0,
                duration: 200,
                useNativeDriver: true,
              }).start();
            }}
          >
            <LeftArrow16 />
            <Text
              style={{
                color: Colors.light.hereworksBlue500,
                fontFamily: 'Roboto_400Regular',
                fontSize: 12,
                lineHeight: 22,
                marginStart: 8,
              }}
            >
              Template groups
            </Text>
          </TouchableOpacity>
          {canAddTemplates && <TouchableOpacity
            style={styles.createButton}
            onPress={() => {
              logEvent('AssetMgmtScreenMobile', 'Create_new_template');
              // showAlert('Feature coming soon!', null, false);
              setAddTemplateModalVisible(true);
            }}
          >
            <PlusIcon />
            <Text style={styles.createButtonTitle}>Add Template</Text>
          </TouchableOpacity>}
        </View>
      </View>
    </Animatable.View>
  );

  const renderAssetSidebar = () => (
    <>
      {assetDrawerOpen && (
        <TouchableOpacity
          style={{
            backgroundColor: '#00000040',
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 5,
          }}
          onPress={() => setAssetDrawerOpen(false)}
        />
      )}
      <Animated.View
        style={{
          width: 300,
          position: 'absolute',
          height: '100%',
          zIndex: 5,
          backgroundColor: Colors.light.hereworksBlue50,
          transform: [{ translateX: assetDrawerInset }],
        }}
      >
        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: assetFilterVisible
              ? Colors.light.hereworksBlue300
              : Colors.light.hereworksBlue50,
          }}
          onPress={() => setAssetFilterVisible(!assetFilterVisible)}
        >
          <Text
            style={{
              fontFamily: 'Roboto_500Medium',
              fontSize: 12,
              lineHeight: 20,
              color: assetFilterVisible ? '#fff' : Colors.light.hereworksBlack500,
              marginTop: 24,
              marginStart: 24,
              marginBottom: 17,
            }}
          >
            {roomSelected ? 'BY ROOM' : 'BY TEMPLATE'}
          </Text>
          <OrionArrowIcon
            style={{
              position: 'absolute',
              right: 24,
              transform: [{ rotateZ: assetFilterVisible ? '90deg' : '270deg' }],
            }}
            color={assetFilterVisible ? '#fff' : Colors.light.hereworksBlack500}
          />
        </TouchableOpacity>
        <View style={{ backgroundColor: Colors.light.hereworksBlue100, height: 1, width: '100%' }}>
          {assetFilterVisible && (
            <View
              style={{
                backgroundColor: Colors.light.hereworksWhite200,
                position: 'absolute',
                top: 0,
                zIndex: 1,
                width: '100%',
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: Colors.light.hereworksBlue100,
              }}
            >
              {roomSelected && (
                <TouchableOpacity
                  style={{ paddingLeft: 24, paddingVertical: 13 }}
                  onPress={() => {
                    setRoomSelected(false);
                    setSelectedTemplate(null);
                    setAllSelected(false);
                    setSelectedId(null);
                    setSelectedRoom(null);
                    setAssetFilterVisible(false);
                  }}
                >
                  <Text>BY TEMPLATE</Text>
                </TouchableOpacity>
              )}
              {!roomSelected && (
                <TouchableOpacity
                  style={{ paddingLeft: 24, paddingVertical: 13 }}
                  onPress={() => {
                    setRoomSelected(true);
                    setSelectedTemplate(null);
                    setAllSelected(false);
                    setSelectedId(null);
                    setSelectedRoom(null);
                    setAssetFilterVisible(false);
                  }}
                >
                  <Text>BY ROOM</Text>
                </TouchableOpacity>
              )}
            </View>
          )}
        </View>
        <View
          style={{
            zIndex: -1, height: '100%', paddingBottom: 40, flex: 1,
          }}
        >
          {roomSelected ? <FlatList
            data={Object.keys(rooms ?? []).sort()}
            renderItem={({ item }) => <View
              style={{ zIndex: -1 }}>
              {renderRoom(rooms[item])}
            </View>}
            keyExtractor={(item) => `roome_menu_item_${item}`}
          /> : <FlatList
            data={templates
              ?.sort((prev: Template, next: Template) => prev.name.localeCompare(next.name))}
            renderItem={({ item }) => <View style={{ zIndex: -1 }}>
              {renderTemplate(item)}
            </View>}
            ref={(ref) => {
              templateMenuList.current = ref;
            }}
            keyExtractor={(item) => `template_menu_item_${item.id}`}
          />}
        </View>
      </Animated.View>
    </>
  );

  const safeAreaInsets = useSafeAreaInsets();

  const renderSearchPane = () => (searchValue?.length ? <SearchResultsPane
    {...{
      searchValue, templates, templateGroups, setSearchValue, selectedTemplate,
    }}
    assets={allAssets}
    selectTemplate={setSelectedTemplate}
    selectAsset={setSelectAsset}
    selectTemplateGroup={setSelectedGroupID}
    showAssets={setLinkAssetsView}
    selectedAsset={selectAsset}
    selectedTemplateGroup={selectedGroupID}
    assetsShown={linkAssetsView}
  /> : null);

  const scanner = () => {
    if (!status?.granted && status?.canAskAgain) {
      return <Text>Requesting for camera permission</Text>;
    }
    if (!status?.granted) {
      return <Text>No access to camera</Text>;
    }

    return (
      <CameraView
        onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
        style={StyleSheet.absoluteFillObject}
      />
    );
  };

  if (assetsLoading) {
    return <View style={{ flex: 1 }}>
      <View style={{ flex: 1, justifyContent: 'center' }}>
        <ActivityIndicator size={'large'} color={Colors.light.hereworksLoading} />
      </View>
    </View>;
  }

  const deleteAsset = (assetId: string) => {
    let updatedAssets: AssetInstance[] = [...assets];
    updatedAssets = updatedAssets.filter((asset) => asset.id !== assetId);
    setAssets(updatedAssets);
    setSelectAsset(null);
    setAssetFilterResults(assetFilterResults?.filter((asset) => asset.id
      !== assetId));
  };

  const updateAsset = (updatedAsset: AssetInstance) => {
    setSelectAsset(updatedAsset);
    setAssets(assets.map((asset: AssetInstance) => (asset.id
      === updatedAsset.id ? updatedAsset : asset)));
    setAssetFilterResults(assetFilterResults?.map((asset: AssetInstance) => (asset.id
      === updatedAsset.id ? updatedAsset : asset)));
  };

  const renderItem = ({ item }) => (
    <AssetRowMobile
      asset={item}
      selected={allSelected ?? null}
      selectAsset={() => setSelectAsset(item)}
      selectionChanged={() => {
        if (allSelected) setAllSelected(null);
      }}
    />
  );

  const paddingTop: number = safeAreaInsets.top;

  return (
    <View
      style={{
        backgroundColor: Colors.light.hereworksBackground,
        flex: 1,
        overflow: 'hidden',
        paddingTop,
      }}
    >
      <AssetFilter
        {...{
          logEvent,
          assetFilterLoading,
          setAssetFilterLoading,
          detailedFilterVisible,
          setDetailedFilterVisible,
          assetFilterResults,
          setAssetFilterResults,
        }}
        clearAssetFilter={clearAssetSearchResults}
      />
      <Modal
        isVisible={!scanned}
        style={{ alignItems: 'center', margin: 0 }}
        onSwipeComplete={() => setScanned(true)}
        swipeDirection={'down'}
        animationIn={'fadeIn'}
        animationOut={'fadeOut'}
      >
        {scanner()}
        <TouchableOpacity
          onPress={() => setScanned(true)}
          style={[Style.closeButton, { top: safeAreaInsets.top ?? 32 }]}
        >
          <CloseModalIcon />
        </TouchableOpacity>
      </Modal>
      <Modal isVisible={nfcPressed} style={{ justifyContent: 'flex-end', margin: 0 }}>
        <View style={{
          width: '100%',
          backgroundColor: '#FFF',
          paddingBottom: 32,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          paddingHorizontal: 12,
          alignItems: 'center',
        }}>
          <Text style={styles.scanSubtitle}>Approach tag</Text>
          <View style={{ paddingVertical: 12 }}>
            <NfcIcon />
          </View>
          <Button style={{ flex: undefined, alignSelf: 'stretch', marginTop: 8 }} title='Cancel NFC Scan' onPress={() => {
            setNfcPressed(false);
            NfcManager.cancelTechnologyRequest();
          }} />
        </View>
      </Modal>
      <AddAssetModal
        visible={addAssetModalVisible}
        setModalVisible={setAddAssetModalVisible}
        template={selectedTemplate}
        addAsset={loadAssets}
      />
      <View style={styles.tabSection}>
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <TouchableOpacity
            onPress={() => {
              clearTabSelection();
              setLinkAssetsView(false);
            }}
            activeOpacity={!linkAssetsView ? 1 : undefined}
          >
            <Text
              style={{
                fontSize: 16,
                lineHeight: 24,
                fontFamily: 'Poppins_400Regular',
                color: !linkAssetsView
                  ? Colors.light.hereworksBlack600
                  : Colors.light.hereworksBlack300,
              }}
            >
              Templates
            </Text>
            {!linkAssetsView && <View style={styles.tabSelectionHighlight} />}
          </TouchableOpacity>
          <TouchableOpacity
            style={{ marginStart: 24 }}
            onPress={() => {
              clearTabSelection();
              setLinkAssetsView(true);
            }}
            activeOpacity={linkAssetsView ? 1 : undefined}
          >
            <Text
              style={{
                fontSize: 16,
                lineHeight: 24,
                fontFamily: 'Poppins_400Regular',
                color: !linkAssetsView
                  ? Colors.light.hereworksBlack300
                  : Colors.light.hereworksBlack600,
              }}
            >
              Assets
            </Text>
            {linkAssetsView && <View style={styles.tabSelectionHighlight} />}
          </TouchableOpacity>
          <View style={{ flex: 1, alignItems: 'flex-end', marginRight: 24 }}>
            <>
              <TouchableOpacity
                style={{
                  borderColor: Colors.light.hereworksBlue500,
                  borderRadius: 4,
                  borderWidth: 1,
                  height: 32,
                  width: 32,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onPress={() => {
                  setTemplateSideBarContext(null);
                  setDetailedFilterVisible(false);
                  logEvent('AssetMgmtScreenMobile', 'Export');
                  if (Object.keys(buildings ?? {})?.length > 0) {
                    setExportDropdownShown(!exportDropdownShown);
                  } else exportData();
                }}
                disabled={exporting}
              >
                {exporting ? <ActivityIndicator size='small' />
                  : <DownloadIcon color={Colors.light.hereworksBlue500} />}
              </TouchableOpacity>
              {exportDropdownShown && <View style={styles.exportDropdown}>
                <Pressable
                  onPress={() => {
                    exportData(selectedBuildingId);
                    logEvent('AssetMgmtScreenMobile', 'Export_building_selected');
                  }}
                  style={(state: { hovered: boolean, pressed: boolean }) => [
                    state.hovered && Style.hovered, state.pressed && Style.pressed,
                  ]}
                >
                  <Text style={styles.exportOptionText}>{'Export data for current building'}</Text>
                </Pressable>
                <Pressable
                  onPress={() => {
                    logEvent('AssetMgmtScreenMobile', 'Export_all_selected');
                    exportData();
                  }}
                  style={(state: { hovered: boolean, pressed: boolean }) => [
                    state.hovered && Style.hovered, state.pressed && Style.pressed,
                  ]}
                >
                  <Text style={styles.exportOptionText}>{'Export data for all buildings'}</Text>
                </Pressable>
              </View>}
            </>
          </View>
        </View>
      </View>
      {!linkAssetsView && renderManageGroupsView()}
      {linkAssetsView && (
        <View
          style={{
            borderRadius: 24,
            marginTop: 20,
            backgroundColor: '#fff',
            flex: 1,
            zIndex: 1,
          }}
        >
          {!templatesLoading && renderAssetSidebar()}
          <View
            style={{
              flex: 1,
              zIndex: 4,
            }}
          >
            <View style={{ zIndex: 4, flex: 1 }}>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  paddingHorizontal: 24,
                }}
              >
                <Text
                  style={{
                    fontFamily: 'Roboto_500Medium',
                    fontSize: 12,
                    lineHeight: 20,
                    color: Colors.light.hereworksBlack500,
                    marginTop: 24,
                    marginBottom: 17,
                  }}
                >
                  ASSETS
                </Text>
                {!(assetFilterResults?.length > 0)
                  && (selectedTemplate?.name || selectedRoom?.LocationRoom) && <Text
                    style={{
                      fontFamily: 'Roboto_500Medium',
                      fontSize: 12,
                      lineHeight: 20,
                      color: Colors.light.hereworksBlack500,
                      marginTop: 24,
                      marginStart: 4,
                      marginBottom: 17,
                    }}
                  >
                    {`> ${(selectedTemplate?.name ?? selectedRoom?.LocationRoom)?.toUpperCase()}`}
                  </Text>}
              </View>
              <View
                style={{ backgroundColor: Colors.light.hereworksBlue100, height: 1, width: '100%' }}
              />
              {selectAsset === null && (<>
                <View style={styles.searchBoxRow}>
                  <View style={styles.searchBox}>
                    <SearchIcon style={{ marginStart: 14 }} />
                    <TextInput
                      placeholder="Search"
                      onFocus={closeMenus}
                      style={styles.searchText}
                      placeholderTextColor={Colors.light.hereworksBlack400}
                      value={searchValue}
                      onChangeText={(text) => {
                        setSearchValue(text);
                      }}
                    />
                  </View>
                  <Pressable
                    onPress={async () => {
                      logEvent('AssetMgmtScreenMobile', 'nfc_icon');
                      if (Platform.OS === 'android') setNfcPressed(true);
                      try {
                        await NfcManager.start();
                        await NfcManager.requestTechnology(NfcTech.Ndef);
                        const tag = await NfcManager.getTag();
                        NfcManager.cancelTechnologyRequest();
                        const decodedTag = decodePayload(tag.ndefMessage[0].payload);
                        setScanned(true);
                        if (decodedTag) handleBarCodeScanned({ data: decodedTag });
                        // handleBarCodeScanned({ data: 'https://dev.hereworks.tech/asset00492?ss=QR' });
                      } finally {
                        setNfcPressed(false);
                        NfcManager.cancelTechnologyRequest();
                      }
                    }}
                    style={(state) => [styles.editDeleteButton, state.pressed && Style.pressed]}
                  >
                    <NfcIcon24 />
                  </Pressable>
                  <Pressable
                    onPress={() => {
                      setScanned(!scanned);
                      logEvent('AssetMgmtScreenMobile', 'scan_icon');
                    }}
                    style={(state) => [styles.editDeleteButton, state.pressed && Style.pressed]}
                  >
                    <ScanIcon16 />
                  </Pressable>
                  <Pressable
                    onPress={() => {
                      logEvent('AssetMgmtScreenMobile', 'Filter_button');
                      setDetailedFilterVisible(true);
                    }}
                    style={(state) => [styles.editDeleteButton, state.pressed && Style.pressed]}
                  >
                    <FilterIconMobile16 />
                  </Pressable>
                </View>
                {renderSearchPane()}
              </>
              )}
              {selectAsset === null && (
                <View
                  style={{
                    flexDirection: 'row',
                    marginTop: 12,
                    paddingBottom: 7,
                    marginHorizontal: 22,
                    alignSelf: 'stretch',
                    alignItems: 'center',
                    borderColor: Colors.light.hereworksWhite500,
                    borderBottomWidth: 1,
                  }}
                >
                  {deleteEnabled && (
                    <Pressable
                      onPress={() => {
                        logEvent('AssetMgmtScreenMobile', 'all_selected');
                        setAllSelected(!allSelected);
                      }}
                      style={(state) => [state.pressed && Style.pressed]}
                    >
                      <CheckBox
                        checkcolor={allSelected ? undefined : '#fff'}
                        color={allSelected ? undefined : Colors.light.hereworksBlue100}
                        style={{ marginStart: 26, marginRight: 14 }}
                      />
                    </Pressable>
                  )}
                  <View style={{ flexDirection: 'row', flex: 1 }}>
                    <View style={{ marginStart: 44, justifyContent: 'center' }}>
                      <Text style={styles.headerText}>IMAGE</Text>
                    </View>
                    <View style={styles.sortContainer}>
                      <Pressable
                        onPress={() => {
                          setSortById(!sortById);
                        }}
                        style={(state) => [{
                          flexDirection: 'row',
                          alignItems: 'center',
                          borderWidth: 1,
                          borderRadius: 4,
                          backgroundColor: sortById ? Colors.light.hereworksWhite100 : '#fff',
                          borderColor: sortById ? Colors.light.hereworksWhite500 : '#fff',
                        }, state.pressed && Style.pressed]}
                      >
                        <OrionArrowIcon
                          style={{ transform: [{ rotateZ: sortById ? '90deg' : '270deg' }] }}
                        />
                        <Text style={styles.headerText}>ID</Text>
                      </Pressable>
                    </View>
                  </View>
                </View>
              )}
              {!assetsLoading && <FlatList
                style={{ paddingHorizontal: 24 }}
                refreshControl={<RefreshControl
                  refreshing={templatesLoading || assetsLoading}
                  onRefresh={loadAssets}
                />}
                data={assetFilterResults?.length > 0 ? assetFilterResults : filterAssets()}
                renderItem={renderItem}
                initialNumToRender={5}
                ListEmptyComponent={
                  !selectedTemplate && !(filterAssets().length > 0) ? <View
                    style={{
                      backgroundColor: Colors.light.hereworksWhite100,
                      borderRadius: 8,
                      margin: 8,
                      paddingVertical: 8,
                      paddingHorizontal: 16,
                    }}>
                    <Text style={{ fontFamily: 'Poppins_500Medium', fontSize: 14, color: Colors.light.hereworksBlack600 }}>
                      {'No template selected'}
                    </Text>
                    <Text style={{ fontFamily: 'Roboto_400Regular', fontSize: 12, color: Colors.light.hereworksBlack400 }}>
                      {'Please select a template from the list or search for an asset'}
                    </Text>
                  </View>
                    : <ScreenEmptyState
                      image={<NoAssetsImage />}
                      title='Add asset to template'
                      subtitle='Add asset to current template'
                      buttonTitle='Add asset'
                      buttonAction={() => setAddAssetModalVisible(true)}
                      style={styles.mobileEmptyState}
                      actionAvailable={canAddAssets}
                    />}
                keyExtractor={(item, index) => String(index)}
              />}
              {(assetsLoading || assetFilterLoading) && <View style={{ flex: 1, justifyContent: 'center' }}>
                <ActivityIndicator size={'large'} color={Colors.light.hereworksLoading} />
              </View>}
              {selectAsset && (
                <View
                  style={{
                    position: 'absolute',
                    backgroundColor: '#fff',
                    flex: 1,
                    width: '100%',
                    top: 62,
                    bottom: 0,
                    alignSelf: 'stretch',
                  }}
                >
                  <AssetCardMobile
                    {...{
                      templates, ticketCountRefresh, showScreenAlert,
                    }}
                    tags={selectedAssetTags}
                    setTags={setSelectedAssetTags}
                    tagIndex={selectedAssetTagIndex}
                    setTagIndex={setSelectedAssetTagIndex}
                    asset={selectAsset}
                    buildingId={selectedBuildingId}
                  />
                </View>
              )}
            </View>
            {showParentAnalytics && (
              <View
                style={{
                  marginTop: 32,
                  borderRadius: 10,
                  width: 338,
                  height: '100%',
                  backgroundColor: Colors.light.hereworksPaleBlue700,
                  opacity: 0,
                }}
              >
                <Text style={styles.parentTitle}>Parent analytics</Text>
                <View style={{ flexDirection: 'row', marginHorizontal: 24 }}>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>ID NUMBER</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>42956381</Text>
                  </View>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>CREATED ON</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>June 16, 2022</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', marginHorizontal: 24 }}>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>CREATED BY</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>Michael Bell</Text>
                  </View>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>TOTAL REPORTS</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>3139</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', marginHorizontal: 24 }}>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>TOTAL DESKS</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>600</Text>
                  </View>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>TOTAL FLOORS</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>3</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', marginHorizontal: 24 }}>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>ASSETS</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>600</Text>
                  </View>
                  <View style={styles.parentTile}>
                    <Text style={styles.parentTileTitle}>TOTAL ROOMS</Text>
                    <Text style={[{ marginStart: 14 }, styles.rowText]}>37</Text>
                  </View>
                </View>
              </View>
            )}
            <View style={[styles.bottomButtons, selectAsset && { justifyContent: 'space-between' }]}>
              <Pressable
                style={({ pressed }) => [
                  styles.backButton,
                  pressed ? { backgroundColor: Colors.light.hereworksWhite300 } : {},
                ]}
                onPress={() => {
                  if (selectAsset === null) setAssetDrawerOpen(true);
                  else setSelectAsset(null);
                }}
              >
                <LeftArrow16 />
                <Text
                  style={{
                    color: Colors.light.hereworksBlue500,
                    fontFamily: 'Roboto_400Regular',
                    fontSize: 12,
                    lineHeight: 22,
                    marginStart: 8,
                  }}
                >
                  {selectAsset === null ? 'Menu' : 'Back to list'}
                </Text>
              </Pressable>
              {selectAsset === null ? (canAddAssets
                && <TouchableOpacity
                  style={styles.createButton}
                  onPress={() => {
                    logEvent('AssetMgmtScreenMobile', 'Create_new_asset');
                    setAddAssetModalVisible(!addAssetModalVisible);
                  }}
                >
                  <PlusIcon />
                  <Text style={styles.createButtonTitle}>{'Add Asset'}</Text>
                </TouchableOpacity>
              )
                : <View style={styles.buttonContainer}>
                  <Pressable
                    style={(state) => [state.pressed && Style.pressed, {
                      borderColor: Colors.light.hereworksBlue500,
                      borderRadius: 4,
                      borderWidth: 1,
                      marginStart: 8,
                      height: 32,
                    }]}
                    onPress={() => {
                      const template: Template = selectedTemplate ?? templates
                        ?.filter((t: Template) => t.id === selectAsset.templateId)[0];
                      logEvent('AssetMgmtScreenMobile', 'ppm_button');
                      const ppmLink = `${template?.ppmUrl}${selectAsset.id}`;
                      if (!template?.ppmUrl) showScreenAlert('Error', PPM_URL_MISSING, true, null, null, true);
                      else openInNewTab(ppmLink);
                    }}
                  >
                    <Text style={{
                      color: Colors.light.hereworksBlue500,
                      fontFamily: 'Roboto_400Regular',
                      fontSize: 12,
                      padding: 8,
                    }}>PPM</Text>
                  </Pressable>
                  {canUpdateAssets && <Pressable
                    style={(state) => [state.pressed && Style.pressed, styles.editDeleteButton]}
                    onPress={() => {
                      logEvent('AssetMgmtScreenMobile', 'edit_asset_icon');
                      setEditAssetVisible(true);
                    }}
                  >
                    <EditIcon color={Colors.light.hereworksBlue500} />
                  </Pressable>}
                  <Pressable
                    style={(state) => [state.pressed && Style.pressed, styles.editDeleteButton]}
                    onPress={() => {
                      logEvent('AssetMgmtScreenMobile', 'report_issue_icon');
                      setReportIssueModalVisible(true);
                    }}
                  >
                    <ReportIssueIcon />
                  </Pressable>
                  {canDeleteAssets && <PressableStyled
                    style={[
                      styles.editDeleteButton,
                      { borderColor: Colors.light.hereworksRed500 },
                    ]}
                    onPress={() => {
                      logEvent('AssetMgmtScreenMobile', 'delete_asset_icon');
                      showScreenAlert(
                        'Delete the asset?',
                        <Text>
                          {' Do you want to delete the asset - '}
                          <Text style={Style.alertBoldText}>{selectAsset.name}</Text>
                          {'?'}
                        </Text>,
                        true,
                        () => {
                          logEvent('AssetMgmtScreenMobile', 'delete_asset_yes');
                          setAssetsLoading(true);
                          retireAsset(selectAsset.id).then((response) => {
                            if (response && !response.isError) {
                              deleteAsset(selectAsset.id);
                              setSelectAsset(null);
                              showScreenAlert('Success', DELETE_ASSET_SUCCESS, false);
                            } else deleteError(response?.errorText);
                            setAssetsLoading(false);
                          }).catch((error) => {
                            deleteError(error?.errorText);
                            setAssetsLoading(false);
                          });
                        },
                        'Delete',
                      );
                    }}
                  >
                    <BinIcon color={Colors.light.hereworksRed500} />
                  </PressableStyled>}
                </View>}
            </View>
          </View>
        </View>
      )}
      <AlertModal modalVisible={alertVisible}
        title={alertTitle}
        message={alertMessage}
        error={alertError}
        action={alertAction}
        actionTitle={alertActionTitle}
        setModalVisible={setAlertVisible}
        isMessage={alertIsMessage} />
      {selectAsset && <>
        <ReportTicketModal
          isVisible={reportIssueModalVisible}
          hide={() => setReportIssueModalVisible(false)}
          assetName={selectAsset.name}
          template={templates?.filter((prototype: { id: string }) => selectAsset
            ?.templateId === prototype.id)[0]}
          solveTagId={(selectedAssetTags[selectedAssetTagIndex] ?? selectedAssetTags[0])
            ?? selectAsset.id}
          refresh={() => setTicketCountRefresh(ticketCountRefresh + 1)}
        />
        <EditAssetModal
          asset={selectAsset}
          visible={editAssetVisible}
          setModalVisible={setEditAssetVisible}
          {...{ updateAsset, deleteAsset }}
          image={selectAsset.imageUrl?.length > 0 ? `${selectAsset.imageUrl}?time=${Date.now()}` : null}
          updateImage={() => { }}
          customFields={loadCustomFields(templates
            ?.filter((template: Template) => selectAsset
              ?.templateId === template.id)[0], selectAsset, false)}
          templateType={templates
            ?.filter((template: Template) => selectAsset?.templateId === template.id)[0].type}
        />
      </>}
    </View>
  );
}

const styles = StyleSheet.create({
  sectionTitle: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    marginStart: 24,
    marginRight: 50,
    marginVertical: 16,
  },
  createButton: {
    borderRadius: 4,
    backgroundColor: Colors.light.hereworksBlue500,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    marginStart: 8,
  },
  createButtonTitle: {
    color: '#fff',
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 22,
    marginStart: 8,
    paddingVertical: 5,
  },
  searchBoxRow: {
    paddingHorizontal: 24,
    marginTop: 10,
    flexDirection: 'row',
  },
  searchBox: {
    marginEnd: 6,
    flex: 1,
    paddingVertical: 4,
    borderRadius: 24,
    backgroundColor: '#fff',
    borderColor: Colors.light.hereworksPaleBlue900,
    borderWidth: 1.5,
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchText: {
    color: Colors.light.hereworksPrimaryGrey,
    marginStart: 9,
    fontFamily: 'Roboto_400Regular',
    flex: 1,
    marginRight: 8,
  },
  selected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    height: 30,
    width: 30,
    borderRadius: 15,
  },
  rowText: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 16,
    color: Colors.light.hereworksPrimaryGrey,
  },
  parentTitle: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 24,
    color: '#000',
    marginStart: 24,
    marginTop: 24,
    marginBottom: 20,
  },
  parentTile: {
    width: 140,
    height: 60,
    marginBottom: 10,
    marginRight: 10,
    backgroundColor: '#fff',
    borderRadius: 10,
    justifyContent: 'center',
  },
  parentTileTitle: {
    marginStart: 14,
    color: Colors.light.hereworksPrimaryGrey900,
    marginBottom: 4,
    fontSize: 11,
  },
  headerText: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 10,
    lineHeight: 15,
    letterSpacing: 0.7,
    marginRight: 8,
    color: Colors.light.hereworksBlack400,
  },
  sortContainer: {
    flex: 1,
    alignItems: 'flex-start',
    marginStart: 30,
  },
  backButton: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue500,
    backgroundColor: '#fff',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 5,
    marginStart: 24,
  },
  bottomButtons: {
    paddingEnd: 24,
    paddingTop: 24,
    paddingBottom: 40,
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  buttonContainer: {
    flexDirection: 'row',
  },
  editDeleteButton: {
    borderColor: Colors.light.hereworksBlue500,
    borderRadius: 4,
    borderWidth: 1,
    height: 32,
    width: 32,
    justifyContent: 'center',
    alignItems: 'center',
    marginStart: 8,
  },
  tabSelectionHighlight: {
    backgroundColor: Colors.light.hereworksBlack600,
    height: 2,
    marginTop: 4,
  },
  noTemplatesTitle: {
    fontSize: 14,
    lineHeight: 21,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_500Medium',
  },
  noTemplatesSubtitle: {
    fontSize: 12,
    lineHeight: 18,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_400Regular',
  },
  noTemplateGroupsMessage: {
    borderRadius: 8,
    backgroundColor: Colors.light.hereworksWhite100,
    paddingHorizontal: 12,
    paddingVertical: 16,
    margin: 16,
  },
  mobileEmptyState: {
    paddingTop: 50,
    paddingBottom: 40,
    flex: 1,
    justifyContent: 'space-between',
  },
  exportDropdown: {
    zIndex: 2,
    position: 'absolute',
    top: 40,
    end: 0,
    backgroundColor: '#FFF',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue200,
  },
  exportOptionText: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  tabSection: {
    marginTop: 16,
    flexDirection: 'row',
    marginStart: 24,
    zIndex: 2,
  },
  scanSubtitle: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 16,
    lineHeight: 20,
    marginTop: 20,
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
  },
});
